"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoyaltyDialogController = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _culture = require("@ori/culture");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../components");
var _constants = require("../constants");
var _logger2 = require("../logger");
var _utils = require("../utils");
var _ApiProvider = require("./ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
const LoyaltyDialogController = ({
  translations
}) => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const translationProps = (0, _utils.getTranslationsProps)({
    currentLanguage: language,
    staticApiUrl,
    tenant,
    translations
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.StrictMode, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
      logger: _logger2.mainLogger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        areaName: `${_constants.APP_NAME}-boundary`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: null,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
            project: _constants.APP_NAME,
            team: _testidGenerator.Team.Checkout,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
              ...translationProps,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                  namespace: _constants.translationsNamespace,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.ClientCultureProvider, {
                    language: language,
                    tenant: tenant,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LoyaltyDialog, {})
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.LoyaltyDialogController = LoyaltyDialogController;
